export const FEED_SUBSCRIBE = `feed/FEED_SUBSCRIBE`
export const FEED_UPDATED = `feed/FEED_UPDATED`
